export default __webpack_public_path__ + "static/media/basicIcon.19355709.svg";